import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import BackButton from "@/components/site/BackButton";

export default function MarketingNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const linkClass = (path) =>
    `overline hover-invert px-3 py-2 border-l border-border ${
      pathname === path ? "text-primary" : "text-foreground hover:text-primary"
    }`;

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border"
      data-testid="marketing-nav"
    >
      <div className="max-w-[1400px] mx-auto flex items-stretch">
        <Link
          to="/"
          className="flex items-center gap-3 px-6 py-4 border-r border-border"
          data-testid="brand-link"
        >
          <span className="w-2 h-2 bg-primary rotate-45 inline-block" />
          <span className="font-serif-display text-2xl leading-none tracking-tight">Draftwave</span>
        </Link>
        <nav className="hidden md:flex items-stretch">
          <Link to="/" className={linkClass("/")} data-testid="nav-home">
            Home
          </Link>
          <Link to="/pricing" className={linkClass("/pricing")} data-testid="nav-pricing">
            Pricing
          </Link>
          <Link to="/workspace" className={linkClass("/workspace")} data-testid="nav-workspace">
            Workspace
          </Link>
          <Link to="/tools" className={linkClass("/tools")} data-testid="nav-tools">
            Free tools
          </Link>
          <Link to="/how-to-draft" className={linkClass("/how-to-draft")} data-testid="nav-how-to-draft">
            How To Draft
          </Link>
          <Link to="/blog" className={linkClass("/blog")} data-testid="nav-blog">
            The Lab
          </Link>
        </nav>
        <div className="ml-auto flex items-stretch">
          {user ? (
            <Link
              to="/dashboard"
              className="px-6 py-4 border-l border-border overline hover-invert hover:text-primary"
              data-testid="nav-dashboard"
            >
              Open studio →
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="px-4 md:px-6 py-4 border-l border-border overline hover-invert hover:text-primary text-[10px] md:text-xs"
                data-testid="nav-signin"
              >
                Sign in
              </Link>
              <Link to="/login" className="border-l border-border" data-testid="nav-cta">
                <Button
                  className="h-full rounded-none px-4 md:px-6 font-mono uppercase tracking-widest text-[10px] md:text-xs"
                  data-testid="nav-cta-button"
                >
                  <span className="hidden sm:inline">Get 120 free credits</span>
                  <span className="sm:hidden">120 free</span>
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
      {pathname !== "/" && (
        <div className="max-w-[1400px] mx-auto px-6 py-2 border-t border-border/60 flex items-center">
          <BackButton />
        </div>
      )}
    </header>
  );
}
